import {ApiDateWrapper} from "../ApiDateWrapper";
import {SC_ApiTimezone} from "../enums/SC_ApiTimezone";

export class SC_GenericFile {
    /**
     * Input property name constants for fromAPI
     */
    protected static inputKeys = {
        internalID: 'internalID',
        href: 'href',
        createDate: 'createDate',
    } as const;

    internalID: number | null;
    protected href: string | null;
    protected createDate: ApiDateWrapper | null;

    constructor({
                    internalID = null,
                    href = null,
                    createDate = null,
                } = {}) {
        this.internalID = internalID;
        this.href = href;
        this.createDate = createDate ? createDate : null;
    }

    get internal_href(): string {
        return `/wp-content/uploads/${this.href}`;
    }

    _clone(other: SC_GenericFile): void {
        this.internalID = other.internalID;
        this.href = other.href;
        this.createDate = other.createDate;
    }

    merge(other: SC_GenericFile): SC_GenericFile {
        if (other.href !== null) this.href = other.href;
        if (other.createDate !== null) this.createDate = other.createDate;

        return this;
    }

    static basicAPIStuff(json: Record<string, any>): Record<string, unknown> {
        return {
            internalID: json[SC_GenericFile.inputKeys.internalID] ?? null,
            href: json[SC_GenericFile.inputKeys.href] ?? null,
            createDate: ApiDateWrapper.fromAPI(json[SC_GenericFile.inputKeys.createDate]),
        };
    }

    rehydrateDates(tz: SC_ApiTimezone) {
        this.createDate = this.createDate?.rehydrate(tz) ?? null;
    }
}
